var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mt-loadmore',{ref:"loadmore",attrs:{"bottom-method":_vm.getMore,"bottom-all-loaded":_vm.allLoaded,"auto-fill":false,"topDistance":0}},[_vm._t("default",null,{"data":_vm.result})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49357650","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/store/components/load-more/index.vue
// module id = null
// module chunks = 